import styled from "@emotion/styled";
import { useCallback, useEffect, useRef, useState } from "react";
import Agua from "@icons-rf/properties-item/agua.svg?react";
import Bath from "@icons-rf/properties-item/bath.svg?react";
import Bed from "@icons-rf/properties-item/bed.svg?react";
import FloorsTotal from "@icons-rf/properties-item/floors-total.svg?react";
import Carro from "@icons-rf/properties-item/carro.svg?react";
import Casa2 from "@icons-rf/properties-item/casa2.svg?react";
import HalfBath from "@icons-rf/properties-item/half-bath.svg?react";
import Measure from "@icons-rf/properties-item/medida.svg?react";
import Pump from "@icons-rf/properties-item/pumps.svg?react";
import { Tooltip } from "@mui/material";
import MoneyFormat from "@/src-refactor/modules/shared/helpers/moneyFormat.helper";

interface IImprovementsIconsProps {
  data?: {
    bathrooms: string | null | number;
    bedrooms: string | null | number;
    half_bathrooms?: string | null | number;
    parking_lot: string | null | number;
    sqm_construction: string | null | number;
    sqm_land: string | null | number;
    floor_level: string | null | number;
    floors_total: string | null | number;
    pumps: string | null | number;
  };
}

function ImprovementsIcons(props: IImprovementsIconsProps) {
  const [scroll, setScroll] = useState({
    left: false,
    right: false
  });
  const contentRef = useRef<HTMLDivElement>(null);

  const checkScroll = useCallback(() => {
    // check if can scroll to left or right
    const element = contentRef.current;
    if (element) {
      setScroll({
        left: element.scrollLeft > 0,
        right: element.scrollLeft + element.clientWidth < element.scrollWidth
      });
    }
  }, []);

  useEffect(() => {
    const element = contentRef.current;
    if (element) {
      element.addEventListener("scroll", checkScroll);
      // Initial check
      checkScroll();
    }

    // Clean up function
    return () => {
      if (element) {
        element.removeEventListener("scroll", checkScroll);
      }
    };
  }, [checkScroll]);
  const orderedItems = [
    {
      icon: Bed,
      value: props.data?.bedrooms,
      label: "Habitaciones"
    },
    {
      icon: Bath,
      value: props.data?.bathrooms,
      label: "Baños"
    },
    {
      icon: HalfBath,
      value: props.data?.half_bathrooms,
      label: "Medios baños"
    },
    {
      icon: Carro,
      value: props.data?.parking_lot,
      label: "Parqueo"
    },
    {
      icon: Agua,
      value: props.data?.floor_level,
      label: "Nivel de piso"
    },
    {
      icon: FloorsTotal,
      value: props.data?.floors_total,
      label: "Total de pisos"
    },
    {
      icon: Casa2,
      value: props.data?.sqm_land ? MoneyFormat(props.data?.sqm_land) : null,
      label: "Metros de Solar",
      sub: true
    },
    {
      icon: Measure,
      value: props.data?.sqm_construction
        ? MoneyFormat(props.data?.sqm_construction)
        : null,
      label: "Metros de construcción",
      sub: true
    }
  ];

  const extraItems = [
    {
      icon: Pump,
      value: props.data?.pumps,
      label: "Bombas"
    }
  ];

  const items = [...orderedItems, ...extraItems].filter(item => item.value);

  useEffect(() => {}, []);
  return (
    <Content
      items={items.length}
      canScrollright={scroll.right}
      canScrollleft={scroll.left}
      ref={contentRef}
    >
      {items.map((item, index) => {
        return (
          <Tooltip key={item.label} title={item.label}>
            <div>
              {item.icon && <item.icon />}
              <span>
                {item.value}{" "}
                {item.sub && (
                  <span>
                    m<sup>2</sup>
                  </span>
                )}
              </span>
            </div>
          </Tooltip>
        );
      })}
    </Content>
  );
}

export default ImprovementsIcons;

const Content = styled.div<{
  items: number;
  canScrollright: boolean;
  canScrollleft: boolean;
}>`
  display: grid;
  grid-template-columns: repeat(7, max-content);
  column-gap: 8px;
  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;

    & > svg {
      width: 16px;
      height: 16px;
      color: var(--m-color-blue-03);
    }

    & > span {
      font-size: 10px;
      color: var(--m-color-blue-03);
    }
  }
`;
